export default __webpack_public_path__ + "static/1-78e503823f05309c8473879edbc129e3.jpeg";